var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./ArchivesBooks.jinja');
require('./ArchivesBooks.less');

var ArchivesBooksInner = require('front/components/ArchivesBooks/ArchivesBooksInner');

var ArchivesBooksTemplate = require('front/components/ArchivesBooks/ArchivesBooksInnerRuntime.jinja');


module.exports = Base.extend({

    template: template,

    events: {
        'click .ArchivesBooks-showMoreButton': 'onClickMoreButton'
    },

    moreApi: function () {
        return this.state.next;
    },

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'ArchivesBooksInner': {selector: '.ArchivesBooksInner', viewConstructor: ArchivesBooksInner}
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'moreApi', 'onResize');

        var limit = 8;

        this.state = {
            next: Urls['front:api:archive-book']() + '?offset=' + this.$('.ArchivesBooksInner-book').size(),
            hasMore: false
        };

        Base.prototype.initialize.call(this, options);
    },


    viewsRegistration: function () {
        Base.prototype.viewsRegistration.call(this);

        $(window).on('resize', this.onResize);

        this.onResize();
    },


    destroy: function () {
        $(window).off('resize', this.onResize);

        return Base.prototype.destroy.call(this);
    },


    onResize: function () {
        var prevTop;
        var $prevItems = $();
        var maxAspect = 0;
        var lines = [];
        var w = this.$('.ArchivesBooksInner-book')
            .eq(0)
            .width();

        this.$('.ArchivesBooksInner-book').each(function (ind, item) {
            var $item = $(item);
            var top = $item.position().top;

            //new line
            if (top != prevTop) {
                if (maxAspect > 0) {
                    lines.push({
                        $items: $prevItems,
                        maxAspect: maxAspect
                    });
                }

                $prevItems = $();
                maxAspect = 0;
            }

            maxAspect = Math.max(maxAspect, $item.find('.ArchivesBooksInner-bookImageWrapper').attr('data-aspect') - 0);
            $prevItems = $prevItems.add($item);
            prevTop = top;
        });

        lines.push({
            $items: $prevItems,
            maxAspect: maxAspect
        });

        _.each(lines, function (line) {
            $(line.$items)
                .find('.ArchivesBooksInner-bookImageWrapper')
                .each(function (indPrev, itemPrev) {
                    $(itemPrev).css({
                        'padding-top': w * line.maxAspect - w * ($(itemPrev).attr('data-aspect') - 0)
                    });
                });
        });
    },


    onClickMoreButton: function (e) {
        var self = this;
        this.$('.ArchivesBooks-showMoreButton').addClass('Button--loading');

        this.forceLoadData(this.moreApi)
            .then(function () {
                self.state.next = self.data.next;
                var $books = $(ArchivesBooksTemplate.render({data: self.data.results}));
                self.state.hasMore = !!self.state.next;

                self.$('.ArchivesBooks-wrapper').append($books);

                app.animateShowMoreSlideDown({$items: $books, hasWrapper: true});

                self.$('.ArchivesBooks-showMoreButton')
                    .toggle(!!self.state.hasMore)
                    .removeClass('Button--loading');

                new ArchivesBooksInner({
                    el: $books[0]
                });

                self.onResize();
            });
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/ArchivesBooks/ArchivesBooks.js
// module id = 156
// module chunks = 0